import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X } from "lucide-react";

export function FloatingChatButton({ isOpen, onClick }) {
  return (
    <div className="relative flex items-center justify-center select-none touch-none">
      <AnimatePresence>
        {!isOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.85, x: 15 }}
            animate={{
              opacity: 1,
              scale: 1,
              x: 0,
              y: [0, -4, 0],
            }}
            exit={{ opacity: 0, scale: 0.85, x: 10 }}
            transition={{
              y: { duration: 2.5, repeat: Infinity, ease: "easeInOut" },
              default: { type: "spring", stiffness: 400, damping: 28 },
            }}></motion.div>
        )}
      </AnimatePresence>

      <motion.button
        type="button"
        onClick={onClick}
        whileTap={{ scale: 0.92 }}
        animate={
          !isOpen ?
            {
              y: [0, -18, 0],
              rotate: [0, -12, 12, 0],
              scale: [1, 1.04, 1],
            }
          : {
              y: 0,
              rotate: 0,
              scale: 1,
            }
        }
        transition={
          !isOpen ?
            {
              y: {
                duration: 3,
                repeat: Infinity,
                ease: "easeInOut",
              },
              rotate: {
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut",
              },
              scale: {
                duration: 2.5,
                repeat: Infinity,
                ease: "easeInOut",
              },
            }
          : {
              type: "spring",
              stiffness: 400,
              damping: 25,
            }
        }
        className="
          relative
          w-20 h-20 md:w-20 md:h-20
          rounded-3xl
          bg-[#00A6D5]
          shadow-[0_8px_30px_rgba(0,188,240,0.35)]
          flex items-center justify-center
          text-white
          cursor-pointer
          z-50
          will-change-transform
        ">
        <AnimatePresence mode="wait">
          {isOpen ?
            <motion.div
              key="close-icon"
              initial={{ opacity: 0, scale: 0.4, rotate: -90 }}
              animate={{ opacity: 1, scale: 1, rotate: 0 }}
              exit={{ opacity: 0, scale: 0.4, rotate: 90 }}
              transition={{ type: "spring", stiffness: 450, damping: 22 }}
              className="absolute inset-0 flex items-center justify-center text-white will-change-transform">
              <X
                size={40}
                strokeWidth={3}
                className="text-white drop-shadow-md"
              />
            </motion.div>
          : <motion.div
              key="chat-icon"
              initial={{ opacity: 0, scale: 0.4, rotate: 45 }}
              animate={{ opacity: 1, scale: 1, rotate: 0 }}
              exit={{ opacity: 0, scale: 0.4, rotate: -45 }}
              transition={{ type: "spring", stiffness: 450, damping: 22 }}
              className="absolute inset-0 flex items-center justify-center will-change-transform">
              <div className="relative flex items-center justify-center">
                <motion.div
                  animate={
                    !isOpen ?
                      {
                        y: [0, -6, 0],
                        rotate: [0, -5, 5, 0],
                        scale: [1, 1.02, 1],
                      }
                    : {
                        y: 0,
                        rotate: 0,
                        scale: 1,
                      }
                  }
                  transition={
                    !isOpen ?
                      {
                        y: {
                          duration: 3,
                          repeat: Infinity,
                          ease: "easeInOut",
                        },
                        rotate: {
                          duration: 4,
                          repeat: Infinity,
                          ease: "easeInOut",
                        },
                        scale: {
                          duration: 2.5,
                          repeat: Infinity,
                          ease: "easeInOut",
                        },
                      }
                    : {
                        type: "spring",
                        stiffness: 400,
                        damping: 25,
                      }
                  }
                  style={{
                    display: "inline-block",
                    originX: 0.5,
                    originY: 0.5,
                    willChange: "transform",
                  }}>
                  <MessageCircle
                    size={55}
                    fill="white"
                    className="text-white drop-shadow-md"
                  />
                </motion.div>

                <span className="absolute -top-1 -right-1 flex h-6 w-6">
                  <span className="absolute inline-flex h-full w-full rounded-full bg-red-600 animate-ping opacity-95"></span>
                  <span className="relative inline-flex rounded-full h-6 w-6 bg-red-600 border-2 border-[#018CF1]"></span>
                </span>
              </div>
            </motion.div>
          }
        </AnimatePresence>
      </motion.button>
    </div>
  );
}
